import { Injectable } from '@angular/core';
import { Contact } from '../models/contact';
import { EntityCollectionServiceBase, EntityCollectionServiceElementsFactory } from '@ngrx/data';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { environment } from '../../environments/environment';
import { ContactsQuery } from '../models/contacts-query';
import { PageResponse } from '../interfaces/page-response';

@Injectable({ providedIn: 'root' })
export class ContactService extends EntityCollectionServiceBase<Contact> {

    constructor(serviceElementsFactory: EntityCollectionServiceElementsFactory, private http: HttpClient) {
        super('Contact', serviceElementsFactory);
    }

    query(query: ContactsQuery): Observable<PageResponse<Contact>> {
        let params = new HttpParams()
            .set('page', query.pageNumber.toString())
            .set('itemsPerPage', query.itemsPerPage.toString());
        if (query.addressBookId) {
            params = params.set('addressBook', query.addressBookId);
        }
        if (query.country) {
            params = params.set('country', query.country);
        }
        if (query.filter) {
            params = params.set('filter', query.filter);
        }
        const headers = new HttpHeaders({
            Accept: 'application/ld+json'
        });
        if (query.sortColumn) {
            params = params.set('order[' + query.sortColumn + ']', query.sortDescending ? 'DESC' : 'ASC');
        }
        return this.http.get<any>(`${environment.apiUrl}/contacts`, { headers, params }).pipe(
            map(r => ({
                totalItems: r['hydra:totalItems'],
                page: r['hydra:member']
            }))
        );
    }

}
